import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../Common/Layout";

export default function Dashboard() {
  const navigate = useNavigate();

  const handleQuickAction = (path: string) => {
    navigate(path);
  };
const metrics = [
    { label: 'New Business MTD', count: 12, rate: '$1,200', link: 'Details' },
    { label: 'Renewals MTD', count: 8, rate: '$800', link: 'Details' },
    { label: 'Rewrite MTD', count: 3, rate: '$300', link: 'Details' },
    { label: 'Quotes MTD', count: 25, rate: '$2,500', link: 'Details' },
    { label: 'Renewing MTD', count: 6, rate: '$600', link: 'Details' },
    { label: 'Ancillary Rev MTD', count: 4, rate: '$400', link: 'Details' },
    { label: 'Agency Fees MTD', count: 2, rate: '$200', link: 'Details' },
    { label: 'Conversation Rate MTD', count: 18, rate: '$1,800', link: 'Details' },
  ];
  return (
    <Layout currentPage="Dashboard">
      <div className="page-container">
        <div className="dashboard-welcome-section">
          <div className="welcome-content">
            <h1 className="dashboard-welcome-title">Good Morning, Agent Smith! 👋</h1>
            <p className="dashboard-welcome-subtitle">Here's your insurance management overview for today - November 17, 2025</p>
          </div>
          <div className="welcome-actions">
            {/* Removed standalone New Quote button. Users must search for a client first. */}
            <button className="welcome-btn secondary" onClick={() => handleQuickAction('/search-client')}>
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
                <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2"/>
              </svg>
              Search Client
            </button>
          </div>
        </div>
        
        <div className="dashboard-grid">
          {metrics.map((m, idx) => (
            <div className="stat-card metric" key={m.label}>
              <div className="stat-header">
                <div className="stat-icon">
                  {/* Optionally, add a unique icon per metric if desired */}
                  <svg viewBox="0 0 24 24" fill="none" width="32" height="32">
                    <circle cx="12" cy="12" r="10" stroke="#36c0c4" strokeWidth="2" fill="#e0f7fa" />
                    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="#2ea6aa">{m.count}</text>
                  </svg>
                </div>
                
              </div>
              <div className="stat-content">
                <h3>{m.label}</h3>
                <span className="stat-change positive">{m.rate}</span>
                <div style={{ color: '#2563eb', fontWeight: 500, fontSize: '0.95em', marginTop: 3, textDecoration: 'underline', cursor: 'pointer' }}>{m.link}</div>
              </div>
            </div>
          ))}
          
          
        </div>
        
        <div className="dashboard-sections">
          <div className="recent-activity">
            <div className="section-header">
              <h3 className="dashboard-section-title">Recent Quotes</h3>
              <button className="view-all-btn">View All</button>
            </div>
            <div className="activity-list">
              <div className="activity-item high-priority">
                <div className="activity-icon new">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2"/>
                    <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="activity-content">
                  <p><strong>Auto Insurance Quote</strong> - Emma Wilson submitted new application</p>
                  <div className="activity-meta">
                    <span className="activity-time">23 minutes ago</span>
                    <span className="activity-badge priority">High Priority</span>
                  </div>
                </div>
                <button className="activity-action">Review</button>
              </div>
              <div className="activity-item">
                <div className="activity-icon approved">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="activity-content">
                  <p><strong>Policy Renewal</strong> - Robert Chen's homeowners policy approved</p>
                  <div className="activity-meta">
                    <span className="activity-time">1 hour ago</span>
                    <span className="activity-badge success">Approved</span>
                  </div>
                </div>
                <button className="activity-action">View</button>
              </div>
              <div className="activity-item">
                <div className="activity-icon message">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="activity-content">
                  <p><strong>Client Inquiry</strong> - Lisa Martinez asking about coverage options</p>
                  <div className="activity-meta">
                    <span className="activity-time">3 hours ago</span>
                    <span className="activity-badge info">Pending Response</span>
                  </div>
                </div>
                <button className="activity-action">Reply</button>
              </div>
              <div className="activity-item">
                <div className="activity-icon payment">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="1" y1="10" x2="23" y2="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="activity-content">
                  <p><strong>Payment Received</strong> - $2,340 commission from State Farm</p>
                  <div className="activity-meta">
                    <span className="activity-time">5 hours ago</span>
                    <span className="activity-badge success">Processed</span>
                  </div>
                </div>
                <button className="activity-action">Details</button>
              </div>
            </div>
          </div>
          <div className="today-tasks">
            <div className="section-header">
              <h3 className="dashboard-section-title">Today's Tasks</h3>
              <button className="add-task-btn">+ Add Task</button>
            </div>
            <div className="tasks-list">
              <div className="task-item urgent">
                <div className="task-checkbox">
                  <input type="checkbox" id="task1" />
                  <label htmlFor="task1"></label>
                </div>
                <div className="task-content">
                  <p><strong>Follow up with Johnson Insurance quote</strong></p>
                  <span className="task-time">Due: 2:00 PM</span>
                </div>
                <div className="task-priority urgent">!</div>
              </div>
              <div className="task-item">
                <div className="task-checkbox">
                  <input type="checkbox" id="task2" />
                  <label htmlFor="task2"></label>
                </div>
                <div className="task-content">
                  <p>Review pending applications (5 remaining)</p>
                  <span className="task-time">Due: End of day</span>
                </div>
                <div className="task-priority normal"></div>
              </div>
              <div className="task-item completed">
                <div className="task-checkbox">
                  <input type="checkbox" id="task3" checked readOnly />
                  <label htmlFor="task3"></label>
                </div>
                <div className="task-content">
                  <p>Call new leads from yesterday</p>
                  <span className="task-time">Completed at 11:30 AM</span>
                </div>
                <div className="task-priority done">✓</div>
              </div>
              <div className="task-item">
                <div className="task-checkbox">
                  <input type="checkbox" id="task4" />
                  <label htmlFor="task4"></label>
                </div>
                <div className="task-content">
                  <p>Prepare weekly performance report</p>
                  <span className="task-time">Due: Tomorrow</span>
                </div>
                <div className="task-priority normal"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="dashboard-quick-actions">
          <div className="quick-actions-header">
            <h3>Quick Actions</h3>
            <p>Jump into your most common tasks</p>
          </div>
          <div className="quick-actions-grid">
            {/* Removed standalone New Quote quick action. Users must search for a client first. */}
            
           
            
            <button className="quick-action-btn" onClick={() => handleQuickAction('/calendar')}>
              <div className="action-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                  <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/>
                  <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/>
                  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <div className="action-content">
                <h4>Calendar</h4>
                <p>Manage appointments</p>
              </div>
            </button>
          </div>
        </div>

        {/* Performance Metrics */}
        <div className="dashboard-metrics">
          <div className="metrics-header">
            <h3 className="metrics-title">Performance This Year</h3>
            {/* <p className="metrics-subtitle">Year-to-date (YTD) KPIs and goals</p> */}
          </div>
          <div className="metrics-grid">
            <div className="metric-card">
              <div className="metric-header">
                <div className="metric-icon conversion">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                    <polyline points="17,11 19,13 23,9" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <span className="metric-trend trend-up">+8.2%</span>
              </div>
              <div className="metric-content">
                <h4>Conversion Rate</h4>
                <p className="metric-value">72.3%</p>
                <div className="metric-progress">
                  <div className="progress-bar" style={{ width: '72.3%' }}></div>
                </div>
                <span className="metric-target">Target: 70%</span>
              </div>
            </div>
            
            <div className="metric-card">
              <div className="metric-header">
                <div className="metric-icon revenue">
                  <svg viewBox="0 0 24 24" fill="none">
                    <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <span className="metric-trend trend-up">+18.5%</span>
              </div>
              <div className="metric-content">
                <h4>Avg Policy Value</h4>
                <p className="metric-value">$3,124</p>
                <div className="metric-progress">
                  <div className="progress-bar" style={{ width: '85%' }}></div>
                </div>
                <span className="metric-target">Target: $3,000</span>
              </div>
            </div>
            
            <div className="metric-card">
              <div className="metric-header">
                <div className="metric-icon satisfaction">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9" stroke="currentColor" strokeWidth="2"/>
                    <line x1="15" y1="9" x2="15.01" y2="9" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <span className="metric-trend trend-neutral">Stable</span>
              </div>
              <div className="metric-content">
                <h4>Client Satisfaction</h4>
                <p className="metric-value">4.9/5</p>
                <div className="metric-progress">
                  <div className="progress-bar" style={{ width: '98%' }}></div>
                </div>
                <span className="metric-target">98% positive feedback</span>
              </div>
            </div>
            
            <div className="metric-card">
              <div className="metric-header">
                <div className="metric-icon response">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                    <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <span className="metric-trend trend-down">-0.3h</span>
              </div>
              <div className="metric-content">
                <h4>Response Time</h4>
                <p className="metric-value">1.8h</p>
                <div className="metric-progress">
                  <div className="progress-bar" style={{ width: '90%' }}></div>
                </div>
                <span className="metric-target">Target: &lt;2h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}